export async function list({commit}, payload) {
  if (typeof payload != 'object') {
    payload = {
      page: payload, 
      pagination: 1,
      exceptId: null
    }
  }
  const {errResponse, data: responseData} = await this.$adminRepositories.template.list(payload);
  if (!errResponse && responseData.success) {
    commit('setItem', responseData.data);
    return responseData.data
  }

  return commit('setItem', payload.pagination ? {} : []);
}

export async function store({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.template.store(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function getDetail(_, id) {
  return this.$adminRepositories.template.detail(id);
}

export async function update({commit}, data) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.template.update(data);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function destroy({dispatch}, id) {
  const response = await this.$adminRepositories.template.destroy(id);
  await dispatch('list');
  return response;
}